import { inject, Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';

import {
  FileResult,
  getFriendlyFileType,
  UploaderFacade,
  UploaderOptions,
} from '@blaze-shared/uploader';

@Injectable({ providedIn: 'root' })
export class UploadFileService {
  private readonly uploaderFacade = inject(UploaderFacade);

  processUpload(options: UploaderOptions, saveAsBase64: boolean): Observable<FileResult[] | void> {
    if (!saveAsBase64) {
      return this.uploaderFacade.upload(options);
    }

    const selectedFiles = options?.preselectFiles || [];
    const files$ = [];

    for (const selectedFile of selectedFiles) {
      const reader = new FileReader();
      const file$ = new Observable<FileResult>((subscriber) => {
        reader.onabort = (err): void => {
          subscriber.error(err);
        };
        reader.onerror = (err): void => {
          subscriber.error(err);
        };
        reader.onloadend = (): void => {
          subscriber.complete();
        };
        reader.onload = (): void => {
          if (typeof reader.result === 'string') {
            const output: FileResult = {
              filename: selectedFile.name,
              mimetype: selectedFile.type,
              size: selectedFile.size,
              type: getFriendlyFileType(selectedFile.name),
              url: reader.result,
            };
            subscriber.next(output);
          }
        };
        return reader.readAsDataURL(selectedFile);
      });
      files$.push(file$);
    }

    return forkJoin(files$);
  }
}
